import * as types from '../constants/ActionTypes';

export function addExerciseToCart(exerciseAddedToCart) {
    return {
        type: types.ADD_EXERCISE_TO_CART,
        exerciseAddedToCart
    };
}

export function addExercisesToCart(exercisesToAdd, newAddedExercises) {
    return {
        type: types.ADD_EXERCISES_TO_CART,
        exercisesToAdd,
        newAddedExercises
    };
}

export function removeExerciseFromCart(exerciseIdRemovedFromCart) {
    return {
        type: types.REMOVE_EXERCISE_FROM_CART,
        exerciseIdRemovedFromCart
    };
}

export function changeHomeworkTitle(homeworkTitle) {
    return {
        type: types.CHANGE_HOMEWORK_TITLE,
        homeworkTitle
    };
}

export function changeHomeworkDescription(homeworkDescription) {
    return {
        type: types.CHANGE_HOMEWORK_DESCRIPTION,
        homeworkDescription
    };
}

export function changeInputStyle() {
    return {
        type: types.CHANGE_INPUT_STYLE
    };
}

export function emptyCart() {
    return {
        type: types.EMPTY_CART
    };
}

export function closeEmptyCartModal() {
    return {
        type: types.CLOSE_EMPTY_CART_MODAL
    };
}

export function openEmptyCartModal() {
    return {
        type: types.OPEN_EMPTY_CART_MODAL
    };
}

export function reorderExercises(exercises) {
    return {
        type: types.REORDER_EXERCISES,
        exercises: exercises
    };
}
